import { supabase } from '../supabaseClient'
import {
  SnookTipoTarea, SnookSexo,
  ResultadoSnookTransporte, ResultadoSnookEmpujeArrastre,
} from './snook-ciriello'

// ===== Evaluaciones Snook y Ciriello por local/puesto de trabajo
// (multi-empresa) — Transporte/Empuje/Arrastre, percentil 90 =====
// Mismo patrón que gestion-tecnica-reba.ts: una sola evaluación por
// registro (no multitarea como NIOSH), inputs y resultado se guardan
// como jsonb libre, tipados aquí para que el resto del código
// (formulario, PDF) no maneje `any`.

export interface SnookCirielloInputs {
  distancia: string
  altura: string
  frecuencia: string
  sinAsasOAgarreDeficiente: boolean
  cargaAlejadaDelCuerpo: boolean
  // Para transporte:
  pesoReal?: number
  // Para empuje/arrastre:
  fuerzaInicialReal?: number
  fuerzaSostenidaReal?: number
}

export type SnookCirielloResultado = ResultadoSnookTransporte | ResultadoSnookEmpujeArrastre

export interface SnookCirielloAssessmentRow {
  id: string
  company_id: string
  job_position_id: string | null
  descripcion: string
  tipo_tarea: SnookTipoTarea
  sexo: SnookSexo
  inputs: SnookCirielloInputs
  resultado: SnookCirielloResultado
  created_by: string | null
  created_at: string
  job_position_name: string | null
}

export interface CreateSnookCirielloAssessmentInput {
  companyId: string
  jobPositionId?: string
  descripcion: string
  tipoTarea: SnookTipoTarea
  sexo: SnookSexo
  inputs: SnookCirielloInputs
  resultado: SnookCirielloResultado
  createdBy: string | null
}

export async function createSnookCirielloAssessment(input: CreateSnookCirielloAssessmentInput): Promise<void> {
  const { error } = await supabase.from('snook_ciriello_assessments').insert({
    company_id: input.companyId,
    job_position_id: input.jobPositionId ?? null,
    descripcion: input.descripcion,
    tipo_tarea: input.tipoTarea,
    sexo: input.sexo,
    inputs: input.inputs,
    resultado: input.resultado,
    created_by: input.createdBy,
  })
  if (error) throw error
}

export async function fetchSnookCirielloAssessments(companyId: string): Promise<SnookCirielloAssessmentRow[]> {
  if (!companyId) return []
  const { data, error } = await supabase
    .from('snook_ciriello_assessments')
    .select('id, company_id, job_position_id, descripcion, tipo_tarea, sexo, inputs, resultado, created_by, created_at, job_positions(name)')
    .eq('company_id', companyId)
    .order('created_at', { ascending: false })
  if (error) throw error
  return (data ?? []).map((r: any) => ({
    id: r.id,
    company_id: r.company_id,
    job_position_id: r.job_position_id,
    descripcion: r.descripcion,
    tipo_tarea: r.tipo_tarea,
    sexo: r.sexo,
    inputs: r.inputs,
    resultado: r.resultado,
    created_by: r.created_by,
    created_at: r.created_at,
    job_position_name: r.job_positions?.name ?? null,
  })) as SnookCirielloAssessmentRow[]
}
